import script from "./ArrowUp.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrowUp.vue?vue&type=script&setup=true&lang=js"

import "./ArrowUp.vue?vue&type=style&index=0&id=f92629ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f92629ec"]])

export default __exports__